import { CaseState } from 'app/area/case/types-store';
import get from 'lodash/get';
import { ComplexValue } from 'ui';
import { expandComplexValueProp } from 'app/area/case/selectors/expand-complex-value-prop';

export const primaryKeyFromContext = (propName: string = 'primaryKey') => 
  (state: CaseState, uiEngineProps: any) => {

  const primaryKey = get(uiEngineProps, 'resolveContext.primaryKey') as ComplexValue<number>;
  
  return { 
    [propName]: primaryKey
  };
};

export const primaryKeyFromContextExpanded = 
  (valueName: string = 'value', minLevelName: string = 'minLevel') => 
    (state: CaseState, uiEngineProps: any) => {
      return expandComplexValueProp(valueName, minLevelName, 'pk')(state, primaryKeyFromContext('pk')(state, uiEngineProps));
};
